const elemWeather = document.querySelectorAll('.wdgt-Weather');
window.fireOnVisible(elemWeather, async () => {
    await import('./assets/js/weather.ts');
});
